import { app } from '../../../../../../../app';
import { Controller } from './import-result.controller';

app.component('companyUserDirectoriesManageGroupAccountsImportResult', {
    bindings: {importResult: '<'},
    controller: Controller,
    templateUrl: require('./import-result.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/import/result/import-result.component.js